export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12913.c5e754f2.jpg";